import { paymentUsersInstance } from '~/services/users/users-instance';

import type { APISubmitW9Response, APIW9StatusResponse, SubmitW9Payload } from './w9.types';

export const getCurrentUserW9Status = async (): Promise<APIW9StatusResponse> => {
  const response = await paymentUsersInstance.get('/w9');
  return response.data;
};

export const submitW9 = async (payload: SubmitW9Payload): Promise<APISubmitW9Response> => {
  const response = await paymentUsersInstance.post('/w9', payload);
  return response.data;
};
